import { createClassName } from 'utils/createClassName';

import './utilityPageLayoutStyles.scss';

export const createUtilityPageLayoutClassName = createClassName('utilityPage');
